import { hideBootstrapModal } from "ws-app"
import { format } from 'timeago.js'
class FileExplorerComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('projects-loaded', (event) => this.onProjectsLoaded(event.detail.projects))
  }

  onProjectsLoaded(projects) {
    this.projects = projects
    this.sortFileListForFileExplorer()

    let str = String.raw`
      <table class="table">
        <tr>
          <th><a href="#" id="sort-files-by-name">Name</a></th>
          <th><a href="#" id="sort-files-by-material">Material</a></th>
          <th><a href="#" id="sort-files-by-modified">Last Modified</a></th>
        </tr>`

    projects.forEach( p => {
        try {
            str += String.raw`
              <tr style="padding: 6px;" id='file-explorer-open-project-${p.key}'>
                <td style="padding: 6px;">${p.title}</td>
                <td style="padding: 6px;">${p.materialName}</td>
                <td style="padding: 6px;">${format(p.modifiedAt)}</td>
              </tr>`
        } catch(error) {
            console.log(error);
        }
    })
    str += '</table>'
    document.getElementById("file-explorer-table").innerHTML = str;
    
    projects.forEach( project => {
      document.getElementById(`file-explorer-open-project-${project.key}`).onclick = async () => { 
        document.dispatchEvent(new CustomEvent('load-project', { detail: project }))
        hideBootstrapModal('modal-file-explorer-dialog')
      }
    })

    document.getElementById('sort-files-by-name').onclick = () => { console.log('fix me') }
    document.getElementById('sort-files-by-material').onclick = () => { console.log('fix me') }
    document.getElementById('sort-files-by-modified').onclick = () => { console.log('fix me') }
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <!-- file explorer -->
    <div class="modal fade" id="modal-file-explorer-dialog" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <h1 class="modal-title fs-5">Open a new beam design</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-body file-explorer-body">
                <div id="file-explorer-table">
                  <em>Empty</em>
                </div>
              </div>
            </div>
          </div>
          <br>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    `
  }

  sortFileListForFileExplorer() {
    switch(fileExplorerCurrentSortBy) {
        case fileExplorerModifiedAtDescending:
            this.projects.sort(function(a, b){
                if(a.modifiedAt > b.modifiedAt) { return -1; }
                if(a.modifiedAt < b.modifiedAt) { return 1; }
                return 0;
            });
            return;
        case fileExplorerModifiedAtAscending:
            this.projects.sort(function(a, b){
                if(a.modifiedAt < b.modifiedAt) { return -1; }
                if(a.modifiedAt > b.modifiedAt) { return 1; }
                return 0;
            });
            return;
        case fileExplorerNameDescending:
            this.projects.sort(function(a, b){
                if(a.title > b.title) { return -1; }
                if(a.title < b.title) { return 1; }
                return 0;
            });
            return;
        case fileExplorerNameAscending:
            this.projects.sort(function(a, b){
                if(a.title < b.title) { return -1; }
                if(a.title > b.title) { return 1; }
                return 0;
            });
            return;
        case fileExplorerMaterialDescending:
            this.projects.sort(function(a, b){
                if(a.materialName > b.materialName) { return -1; }
                if(a.materialName < b.materialName) { return 1; }
                return 0;
            });
            return;
        case fileExplorerMaterialAscending:
            this.projects.sort(function(a, b){
                if(a.materialName < b.materialName) { return -1; }
                if(a.materialName > b.materialName) { return 1; }
                return 0;
            });
            return;
        default: break;
    }
}
}

customElements.define('file-explorer-component', FileExplorerComponent)

let fileExplorerProjects = [];

const fileExplorerModifiedAtDescending = "modifiedAtDescending";
const fileExplorerModifiedAtAscending = "modifiedAtAscending";

const fileExplorerNameDescending = "nameDescending";
const fileExplorerNameAscending = "nameAscending";

const fileExplorerMaterialDescending = "materialDescending";
const fileExplorerMaterialAscending = "materialAscending";

const fileExplorerProjectLimit = 1000

let fileExplorerCurrentSortBy = fileExplorerModifiedAtDescending;

function fileExplorerOpenDesign(beamDesignKey) {
    loadProject(beamDesignKey);
    $('#modal-file-explorer-dialog').modal('hide');
}


function updateFileExplorerList() {
    sortFileListForFileExplorer();

    let str = '<table class="table">';
    str += '<tr><th><a href="#" id="sort-files-by-name">Name</a></th>';
    str += '<th><a href="#" onclick="toggleSortFilesByMaterial()">Material</a></th>';
    str += '<th><a href="#" onclick="toggleSortFilesByLastModified()">Last Modified</a></th>';

    fileExplorerProjects.forEach( p => {
        try {
            str += '<tr style="padding: 6px;" onclick="fileExplorerOpenDesign(\'' + p.key + '\');">';
            //str += '<tr style="padding: 6px;" class="ws-ui-table-row-disable" id="' + p.key + '">';
            str += '<td style="padding: 6px;">' + p.title + '</td>';
            str += '<td style="padding: 6px;">' + p.materialName + '</td>';
            str += '<td style="padding: 6px;">' + format(p.modifiedAt) + '</td>';
            str += '</tr>';
        } catch(error) {
            console.log(error);
        }
    })
    str += '</table>';
    //console.log(str)
    document.getElementById("file-explorer-table").innerHTML = str;

    document.getElementById('sort-files-by-name').onclick = () => { toggleSortFilesByName() }
}

function sortFileListForFileExplorer() {
    switch(fileExplorerCurrentSortBy) {
        case fileExplorerModifiedAtDescending:
            fileExplorerProjects.sort(function(a, b){
                if(a.modifiedAt > b.modifiedAt) { return -1; }
                if(a.modifiedAt < b.modifiedAt) { return 1; }
                return 0;
            });
            return;
        case fileExplorerModifiedAtAscending:
            fileExplorerProjects.sort(function(a, b){
                if(a.modifiedAt < b.modifiedAt) { return -1; }
                if(a.modifiedAt > b.modifiedAt) { return 1; }
                return 0;
            });
            return;
        case fileExplorerNameDescending:
            fileExplorerProjects.sort(function(a, b){
                if(a.title > b.title) { return -1; }
                if(a.title < b.title) { return 1; }
                return 0;
            });
            return;
        case fileExplorerNameAscending:
            fileExplorerProjects.sort(function(a, b){
                if(a.title < b.title) { return -1; }
                if(a.title > b.title) { return 1; }
                return 0;
            });
            return;
        case fileExplorerMaterialDescending:
            fileExplorerProjects.sort(function(a, b){
                if(a.materialName > b.materialName) { return -1; }
                if(a.materialName < b.materialName) { return 1; }
                return 0;
            });
            return;
        case fileExplorerMaterialAscending:
            fileExplorerProjects.sort(function(a, b){
                if(a.materialName < b.materialName) { return -1; }
                if(a.materialName > b.materialName) { return 1; }
                return 0;
            });
            return;
        default: break;
    }
}

let fileExplorerCurrentFileNameSort = fileExplorerNameDescending;
let fileExplorerCurrentMaterialSort = fileExplorerMaterialDescending;
let fileExplorerCurrentFileModifiedAtSort = fileExplorerModifiedAtDescending;

function toggleSortFilesByName() {
    if(fileExplorerCurrentFileNameSort === fileExplorerNameAscending) {
        fileExplorerCurrentFileNameSort = fileExplorerNameDescending;
    } else {
        fileExplorerCurrentFileNameSort = fileExplorerNameAscending;
    }
    fileExplorerCurrentSortBy = fileExplorerCurrentFileNameSort;
    updateFileExplorerList();
}

function toggleSortFilesByMaterial() {
    if(fileExplorerCurrentMaterialSort === fileExplorerMaterialAscending) {
        fileExplorerCurrentMaterialSort = fileExplorerMaterialDescending;
    } else {
        fileExplorerCurrentMaterialSort = fileExplorerMaterialAscending;
    }
    fileExplorerCurrentSortBy = fileExplorerCurrentMaterialSort;
    updateFileExplorerList();
}

function toggleSortFilesByLastModified() {
    if(fileExplorerCurrentFileModifiedAtSort === fileExplorerModifiedAtAscending) {
        fileExplorerCurrentFileModifiedAtSort = fileExplorerModifiedAtDescending;
    } else {
        fileExplorerCurrentFileModifiedAtSort = fileExplorerModifiedAtAscending;
    }
    fileExplorerCurrentSortBy = fileExplorerCurrentFileModifiedAtSort;
    updateFileExplorerList();
}


